import client from './client';

export interface InquiryListItem {
  id: string;
  maskedAuthor: string;
  content: string;
  isFaq: boolean;
  isPinned: boolean;
  adminAnswer: string | null;
  isMine: boolean;
  createdAt: string;
}

export interface InquiryDetail extends InquiryListItem {
  contactEmail: string | null;
  contactPhone: string | null;
}

export interface CreateInquiryPayload {
  content: string;
  contactEmail?: string;
  contactPhone?: string;
}

export async function listInquiries(
  storeId: string,
): Promise<InquiryListItem[]> {
  const res = await client.get<InquiryListItem[]>(
    `/api/stores/${storeId}/inquiries`,
  );
  return res.data;
}

export async function createInquiry(
  storeId: string,
  payload: CreateInquiryPayload,
): Promise<{ id: string }> {
  const res = await client.post<{ id: string }>(
    `/api/stores/${storeId}/inquiries`,
    payload,
  );
  return res.data;
}

export async function getInquiry(
  id: string,
  storeId: string,
): Promise<InquiryDetail> {
  const res = await client.get<InquiryDetail>(`/api/inquiries/${id}`, {
    params: { storeId },
  });
  return res.data;
}
